import { Text, View } from 'react-native'
import { DENSE_TABLE_MAX_FONT_SCALE } from '../leagueDetail.constants'
import { FormLetters } from './FormLetters'
import { TeamKitCell } from './TeamKitCell'
import type { StandingRow } from '../../../src/leagueDetail'
import type { LeagueStandingsTableStyles } from './LeagueStandingsTable.styles'

interface FormRowProps {
  row: StandingRow
  isLast: boolean
  styles: LeagueStandingsTableStyles
  kitSize: number
}

export function FormRow({ row, isLast, styles, kitSize }: FormRowProps) {
  return (
    <View style={[styles.row, styles.rowForm, isLast && styles.rowLast]}>
      <View style={styles.rowLeading} />
      <View style={styles.rowInnerForm}>
        <View style={styles.cellRank}>
          <Text style={styles.rankText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
            {row.rank}
          </Text>
        </View>
        <View style={styles.cellTeamForm}>
          <TeamKitCell
            displayName={row.displayName}
            countryCode={row.countryCode}
            kitPrimary={row.kitPrimary}
            kitSecondary={row.kitSecondary}
            kitType={row.kitType}
            styles={styles}
            kitSize={kitSize}
          />
          <Text style={styles.teamName} numberOfLines={2} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>
            {row.displayName}
          </Text>
        </View>
        <View style={styles.cellFormFixed}>
          <FormLetters row={row} styles={styles} />
        </View>
        <View style={styles.cellPtsForm}>
          <Text style={styles.ptsText} maxFontSizeMultiplier={DENSE_TABLE_MAX_FONT_SCALE}>{row.points}</Text>
        </View>
      </View>
    </View>
  )
}
